module.exports = __webpack_public_path__ + "img/fts_header_cont.c80ff109.png";